import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowLeft, faArrowRight, faBalanceScale, faChartBar, faCheck, faEquals, faStar, faTimes, faVoteYea } from '@fortawesome/free-solid-svg-icons'
import { faCircle,faQuestionCircle, faPlayCircle, faEnvelope } from '@fortawesome/free-regular-svg-icons'
import { faFacebook, faFacebookF, faInstagram, faWhatsapp, faTelegram, faXTwitter, faTiktok } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
    faArrowLeft, faArrowRight, faBalanceScale, faChartBar, faCheck, faEquals, faStar, faTimes, faVoteYea,
    faCircle,faQuestionCircle, faPlayCircle, faEnvelope,
    faFacebook, faFacebookF, faInstagram, faWhatsapp, faTelegram, faXTwitter, faTiktok
)

export default FontAwesomeIcon;
